import React from 'react'
import Layout from '../components/Layout'
import * as styles from '../styles/wholesale.module.scss'
import { graphql } from 'gatsby'
import { getImage, StaticImage } from 'gatsby-plugin-image'
import Header from '../components/Header'
import VerveH1 from '../components/VerveH1'

export default function Wholesale({ data }) {

  const banner = getImage(data.banner)
  
  return (
    <Layout pageTitle="Wholesale">
      <Header imageData={banner} bgClass={styles.header_bg}>
        <VerveH1 h1="wholesale"/>
      </Header>
      <section className={styles.wholesale_intro} id="main">
        <div className="container">
          <h2>Let's Work Together</h2>
          <div className={styles.intro_containers}>
            <div className={styles.intro_container}>
              <StaticImage 
                className={styles.container_img}
                src="../images/core_flavors/blueberries.jpg"
                alt="a bottle of lemon verbena flavored Verve kombucha"
                placeholder="blurred"
                width={600}
              />
              <div className={styles.container_info}>
                <h3>Bottles by the Case</h3>
                <p>Our kombucha is offered in cases of 12 bottles. Whether you enjoy our kombucha by itself or as a cocktail mixer, bottles are a great option to try multiple flavors</p>
              </div>
            </div>
            <div className={styles.intro_container}>
              <StaticImage 
                className={styles.container_img}
                src="../images/bottled_verve_kombucha.jpg"
                alt="a bottle of lemon verbena flavored Verve kombucha"
                placeholder="blurred"
                width={600}
              />
              <div className={styles.container_info}>
                <h3>Kegs</h3>
                <p>Our keg offerings change throughout the year with a variety of different flavors. Limited supply with some special offerings that you might just not see in bottles.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.wholesale_imgs}>
        <ul className={styles.wholesale_gallery}>
          <li>
            <StaticImage
              src="../images/alex_ted_andy.png"
              alt="Verve Kombucha Owners - Alex and Andy"
              placeholder="blurred"
              width={1000}
            />
          </li>
          <li>
            <StaticImage
              src="../images/bottled_verve_kombucha_tall.jpg"
              alt="bottles of kombucha"
              placeholder="blurred"
              width={1000}
            />
          </li>
        </ul>
      </section>
      <section className={styles.wholesale_form}>
        <div className="container">
          <div className={styles.wholesale_form_intro}>
            <h2>Want to be a wholesale partner?</h2>
            <p>Contact us below.</p>
          </div>
        <form 
            name="wholesale"
            // action="/contact/success" - redirect here after form submission
            method="POST"
            data-netlify="true"
            netlify-honeypot="bot-field"
            data-netlify-recaptcha="true"
          >
            <span className={styles.hidden}>
              <label>
                Don’t fill this out if you’re human: <input name="bot-field" />
              </label>
            </span>          
            <span>
              <label className={styles.required} htmlFor="name">Name: </label>
              <input type="text" name="name" id="name" required />
            </span>
            <span>
              <label htmlFor="business">Business Name: </label>
              <input type="text" name="business" id="business" />
            </span>
            <span>
              <label className={styles.required} htmlFor="email">Email: </label>
              <input type="email" name="email" id="email" required />
            </span>
            <span>
              <label htmlFor="phone">Phone: </label>
              <input type="tel" name="phone" id="phone" />
            </span>
            <span>
              <label htmlFor="subject">Subject: </label>
              <input type="text" name="subject" id="subject" />
            </span>
            <span>
              <label className={styles.required} htmlFor="message">Message: </label>
              <textarea name="message" id="message" rows="10" required/>
            </span>
            <span className={styles.form_footer}>
              <div data-netlify-recaptcha="true"></div>
              <button className="button_slide" type="submit">Send</button>
            </span>
          </form>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    banner: file(relativePath: {eq: "verve_interior_ceiling.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: BLURRED
        )
      }
    }
  }
`;